import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: "https://ab71c362016e472a9dc0e43c6ab2691a@o393176.ingest.sentry.io/5241849",
  environment: import.meta.env.VITE_APP_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_APP_SENTRY_RELEASE,
  debug: import.meta.env.VITE_APP_SENTRY_DEBUG === "true",
  enabled: ["production", "e2e"].includes(process.env.NODE_ENV!),
  ignoreErrors: ["ResizeObserver", "No Token"],
  beforeSend: (event) => {
    // wrong login or password error
    if (
      event.request?.url?.includes("/login") &&
      (event.exception?.values?.[0]?.value?.includes("401") ||
        event.exception?.values?.[0]?.value?.includes("403"))
    ) {
      return null;
    }

    if (
      event.request?.url?.includes("/accounts") &&
      event.request?.method === "DELETE" &&
      event.exception?.values?.[0]?.value?.includes("406")
    ) {
      return null;
    }

    // email already taken error
    if (
      event.request?.url?.includes("/signup") &&
      event.exception?.values?.[0]?.value?.includes("406")
    ) {
      return null;
    }

    // frequent tests error
    if (
      import.meta.env.VITE_APP_SENTRY_ENVIRONMENT === "e2e" &&
      event.exception?.values?.[0]?.value?.includes("406")
    ) {
      return null;
    }

    return event;
  },
});
